<template>
  <v-footer padless class="mt-5">
    <v-card class="flex" flat tile>
      <v-card-text class="py-2 text-center grey--text text-caption">
        {{ new Date().getFullYear() }} &mdash;
        <strong>GymPro</strong> &nbsp;·&nbsp;
        By: <strong>Dvarela</strong>
      </v-card-text>
    </v-card>
  </v-footer>
</template>

<script>
export default {
  name: 'PieComponent',
}
</script>


// WEBPACK FOOTER //
// src/components/Dialogos/PieComponent.vue